import React, { Component } from 'react';
import Markdown from 'markdown-to-jsx';
import PropTypes from 'prop-types';
// import SaleProductItem from 'SaleProduct/SaleProductItem';
// import SaleProductPlaceholder from 'SaleProduct/SaleProductsPlaceholder';
// import { CardDeck } from 'reactstrap';
import Faq from './Faq';

class MarkdownRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: 'loading...',
      products: [],
    };
  }

  static propTypes = {
    loadContent: PropTypes.func,
    content: PropTypes.string.isRequired,
    loadSaleProduct: PropTypes.func,
    fromList: PropTypes.bool,
    hasAccess: PropTypes.bool,
    articleId: PropTypes.number,
  };

  static defaultProps = {
    loadContent: undefined,
    loadSaleProduct: undefined,
    fromList: false,
    hasAccess: false,
    articleId: undefined,
  };

  render() {
    let markdownOptions = {};

    const replaceSection = ({ children, ...props }) => {
      if (props.is === 'page-section') {
        return <Faq question={props.text} answer={children} downArrow={this.props.downArrow} />;
      }
      if (props.is === 'page-section-list') {
        return <section className="faq-section pt-0">{children}</section>;
      }

      if (props.is === 'content') {
        const identifier = props.src;

        if (this.state.content === 'loading...') {
          this.props.loadContent({ identifier }).then((response) => {
            this.setState({
              content: response.data.content.content.markdown,
            });
          });
        }

        return <Markdown options={markdownOptions}>{this.state.content}</Markdown>;
      }

      return <section {...props}>{children}</section>;
    };

    const replaceImg = ({ children, ...props }) => {
      let video;
      let url;

      if (props.src) {
        props.src.match(
          /(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
        );
      }

      if (RegExp.$3.indexOf('youtu') > -1) {
        url = '//www.youtube.com/embed/';
        video = true;
      } else if (RegExp.$3.indexOf('vimeo') > -1) {
        url = '//player.vimeo.com/video/';
        video = true;
      } else {
        video = false;
      }

      if (video) {
        return (
          <div className="ratio ratio-16x9">
            <iframe src={url + RegExp.$6} allowFullScreen title="video" />
          </div>
        );
      }

      return <img className="img-fluid" src={props.src} alt="" />;
    };

    const replaceAside = ({ children, ...props }) => {
      if (props.didYouKnow) {
        return <aside className="did-you-know">{children}</aside>;
      }
      return <aside {...props}>{children}</aside>;
    };

    const replaceTable = ({ children }) => <table className="table">{children}</table>;

    const replaceBlockquote = ({ children }) => <p className="blockquote">{children}</p>;

    const replacePre = ({ children }) => <span>{children}</span>;

    const replaceCode = ({ children }) => <Markdown options={markdownOptions}>{children}</Markdown>;

    const replaceSpan = ({ children }) => <p>{children}</p>;

    const replaceLi = ({ children }) => <li>{children}</li>;

    const replaceH1 = ({ children }) => <h1 className="title-large semi-bold">{children}</h1>;
    const replaceH2 = ({ children }) => <h2 className="title-medium semi-bold">{children}</h2>;
    const replaceH3 = ({ children }) => <h3 className="title-small semi-bold">{children}</h3>;

    markdownOptions = {
      forceInline: this.props.fromList,
      overrides: {
        section: {
          component: replaceSection,
        },
        img: {
          component: replaceImg,
        },
        table: {
          component: replaceTable,
        },
        blockquote: {
          component: replaceBlockquote,
        },
        pre: {
          component: replacePre,
        },
        code: {
          component: replaceCode,
        },
        aside: {
          component: replaceAside,
        },
        span: {
          component: replaceSpan,
        },
        li: {
          component: replaceLi,
        },
        h1: {
          component: replaceH1,
        },
        h2: {
          component: replaceH2,
        },
        h3: {
          component: replaceH3,
        },
      },
    };

    return (
      <Markdown start="1" options={markdownOptions}>
        {this.props.content}
      </Markdown>
    );
  }
}

export default MarkdownRenderer;
